module.exports = __webpack_public_path__ + "static/q10_o-523ce914c73cf77e37b75f46bf079fdc.png";